import React, { useMemo, useState, useEffect, useCallback } from 'react';
import { ButtonColor } from '@lmt/unicorn-shared/app/components/common/ui-kit/buttons/Button';
import { ReactComponent as OkIcon } from '@lmt/unicorn-shared/app/icons/comment-ok.svg';
import { ReactComponent as CancelIcon } from '@lmt/unicorn-shared/app/icons/comment-cancel.svg';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import styles from './UserComments.module.scss';
import { TagsEditor } from '@lmt/unicorn-shared/app/components/common/ui-kit/tags/TagsEditor';
import { IconButton } from '@lmt/unicorn-shared/app/components/common/ui-kit/IconButton';

export interface EditCommentProps {
  comment: string;
  commentId: number;
  editComment: (id: number, comment: string) => void;
  close: () => void;
}

const maxCount = 365;

export const EditCommentBlock: React.FC<EditCommentProps> = (props) => {
  const { comment, commentId, editComment, close } = props;
  const i18n = useScopedTranslation('patients.overview.comments');
  const [updatedComment, setUpdatedComment] = useState<string>('');

  useEffect(() => {
    setUpdatedComment(comment);
  }, [comment]);

  const cancel = useCallback(() => {
    setUpdatedComment(comment);
    close();
  }, [comment, close]);

  const update = useCallback(async () => {
    editComment(commentId, updatedComment);
    close();
  }, [commentId, updatedComment, close, editComment]);

  const wordCount = useMemo(() => {
    return (
      <div className={styles.commentWordCount}>
        {`${updatedComment.length}/${maxCount}`}
      </div>
    );
  }, [updatedComment.length]);

  return (
    <div className={styles.editCommentContainer}>
      <div className={styles.tagsEditorContainer}>
        <TagsEditor
          value={updatedComment}
          onChange={(e, value) => setUpdatedComment(value)}
          isMultiline={true}
          maxAutoHeight={100}
          placeholder={i18n.t('placeholder')}
          maxLength={maxCount}
        />
      </div>
      <div className={styles.editCommentOptions}>
        <div className={styles.editCommentControls}>
          <IconButton
            iconComponent={
              <CancelIcon className={styles.editCommentCancelButtonIcon} />
            }
            testId={'cancel'}
            title={''}
            onClick={cancel}
            color={ButtonColor.Primary}
            className={styles.editCommentCancelButton}
          />
          <IconButton
            disabled={
              updatedComment === comment || !updatedComment.replace(' ', '')
            }
            iconComponent={
              <OkIcon className={styles.editCommentOkButtonIcon} />
            }
            testId={'ok'}
            title={''}
            onClick={update}
            color={ButtonColor.Primary}
            className={styles.editCommentButton}
          />
        </div>
        <div>{updatedComment.length > maxCount / 2 && wordCount}</div>
      </div>
    </div>
  );
};
